const it = {
    // Common
    'Close': 'Chiudi',
    'From': 'Da',
    'To': 'A',
    'Distance': 'Distanza',
    'Estimated time': 'Tempo stimato',
    'Level': 'Piano',
    'Search by name, category, building...': 'Cerca per nome, categoria, edificio...',
    'Show legend': 'Mostra legenda',
    'Ask with AI': 'Chiedi all\'IA',
    'Nothing was found': 'Non è stato trovato nulla',
    'd': 'g',
    'h': 'o',
    'min': 'min',
    'Walk': 'A piedi',
    'Bike': 'Bicicletta',
    'Transit': 'Trasporto pubblico',
    'Drive': 'In auto',
    'Start wayfinding': 'Inizia percorso',
    // Location Details
    'Read full description': 'Leggi la descrizione completa',
    // Locations List
    'Locations': 'Luoghi',
    'Directions not available': 'Indicazioni non disponibili',
    'Start directions': 'Calcola il Percorso',
    // Route instructions
    'Previous': 'Precedente',
    'Next': 'Prossimo',
    'StepYofX': 'Passaggio {{activeStep}} di {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Sei a destinazione',
    'Leave': 'Parti',
    'Park': 'Parcheggia',
    'at': 'a',
    'Building': 'Edificio',
    'Venue': 'Luogo',
    'Take staircase to level': 'Prendi le scale fino al piano',
    'Take the ladder to level': 'Prendi la scala fino al piano',
    'Take elevator to level': 'Prendi l\'ascensore fino al piano',
    'Take escalator to level': 'Prendi la scala mobile fino al piano',
    'Take wheelchair lift to level': 'Prendi il montascale fino al piano',
    'Take wheelchair ramp to level': 'Prendi la rampa per sedie a rotelle fino al piano',
    'Exit': 'Esci',
    'Enter': 'Entra in',
    'stops': 'fermate',
    'and continue': 'e continua',
    'Continue straight ahead': 'Continua dritto',
    'Go left': 'Gira a sinistra',
    'Go sharp left': 'Svolta a sinistra',
    'Go slight left': 'Gira leggermente a sinistra',
    'Go right': 'Gira a destra',
    'Go sharp right': 'Svolta a destra',
    'Go slight right': 'Gira leggermente a destra',
    'Turn around': 'Girati',
    // Wayfinding component
    'Switch': 'Inverti',
    'Avoid stairs and escalators': 'Evita scale e scale mobili',
    'Include bus transportation': 'Includi trasporto in autobus',
    'No route found': 'Nessun percorso trovato',
    'My position': 'La mia posizione',
    'Go!': 'Vai!',
    'Directions': 'Indicazioni',
    'Choose departure': 'Scegli la partenza',
    'Choose destination': 'Scegli destinazione',
    // Venue selector
    'Venues': 'Luoghi',
    'Select venue': 'Seleziona luogo',
    'Current': 'Attuale',
    // QR code dialog
    'Scan QR code': 'Scansiona il codice QR',
    'Scan the QR code to see the route on your phone': 'Scansiona il codice QR per vedere il percorso sul tuo telefono',
    'Done': 'Fatto',
    // Directions
    'Cancel route': 'Annulla percorso',
    'Finish route': 'Termina percorso',
    // Share location link
    'Share': 'Condividi',
    'Copy link': 'Copia il collegamento',
    'QR Code': 'Codice QR',
    //Opening Hours
    'Open': 'Aperto',
    'Closed': 'Chiuso',
    'Expand opening hours': 'Espandi orari di apertura',
    'Collapse opening hours': 'Comprimi orari di apertura',
    // View Selector
    'Go to view': 'Mostra posizione',
    'Close view selector': 'Chiudi selettore vista',
    // Language Selector
    'Select language': 'Seleziona lingua',
    // Accessibility
    'Increase text size to 200%': 'Aumenta la dimensione del testo al 200%',
    'Decrease text size to 100%': 'Riduci la dimensione del testo al 100%',
    // Map Controls
    'Zoom in': 'Ingrandisci',
    'Zoom out': 'Riduci',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Consenso all\'utilizzo',
    'Usage consent message': 'Ask with AI ti aiuta a trovare luoghi e a orientarti in questa struttura utilizzando l\'Intelligenza Artificiale (IA). Sebbene ci impegniamo per garantire la precisione, l\'IA potrebbe talvolta commettere errori. Ti preghiamo di verificare i dettagli importanti prima di metterti in cammino.',
    'Usage consent accept': 'Ho capito',
    'Usage consent decline': 'Rifiuta',
    'AI disclaimer': 'Ask with AI potrebbe commettere errori. Verifica i dettagli importanti prima di metterti in cammino.',
    // Location Consent
    'Location consent message': 'Per fornirti indicazioni personalizzate e aiutarti a scoprire cosa c\'è nelle vicinanze, Ask with AI vorrebbe accedere alla tua posizione. La chat funzionerà comunque senza conoscere la tua posizione, ma dovrai specificare un punto di partenza.',
    'Location consent accept': 'Consenti',
    'Location consent decline': 'Rifiuta',
};

export default it;
